export default function(
    functionObj={},
    variableObject={},
){
    try{
        const {
            functionType='',
            executionObject={}
        } = functionObj;
        const {
            variableName='', variableUnavailable=false
        } = executionObject;
        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }
        let data = '';
        if(functionType === 'windowPathname'){
            data = window && typeof window !== 'undefined' ? window.location.pathname : '';
        }else if(functionType === 'windowHref'){
            data = window && typeof window !== 'undefined' ? window.location.href : '';
        }else if(functionType === 'windowOrigin'){
            data = window && typeof window !== 'undefined' ? window.location.origin : '';
        }else if(functionType === 'windowHostname'){
            data = window && typeof window !== 'undefined' ? window.location.hostname : '';
        }
        variableObject[variableName] = data;
        return {
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableObject,
            hasError : false,
            errorPayload : undefined
        }
    }catch(e){
        console.log('/utils/syncFunctionParser/general/functionTypeParser/idParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        }
    }
}